import { useMediaQuery } from "@mui-wrapper";
import { MAX_HEIGHT_SMALL_SCREEN } from "@constants/ulm-constants";

interface UseMediaQueries {
  /** Whether the screen height is shorter than the MAX_HEIGHT_SMALL_SCREEN value */
  isSmallHeightScreen: boolean;
}

/** Custom hook that returns media queries used along the app */
export function useMediaQueries(): UseMediaQueries {
  const isSmallHeightScreen = useMediaQuery(
    `(max-height: ${MAX_HEIGHT_SMALL_SCREEN})`
  );

  return { isSmallHeightScreen };
}
